export default {
  "NOTES": "Notes"
};
